module.exports = [{
      plugin: require('/tmp/37071a9f/node_modules/gatsby-plugin-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-135060300-1","head":false,"anonymize":true},
    }]
